import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./pessoas.component.html')
})
export class PessoasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/pessoas.component.ts
 **/